import React from "react";

import { JobStatusBox } from "@js/apps/jobs/components/job-status/components/job-status-box";
import type { JobStatusBoxProps } from "@js/apps/jobs/components/job-status/types";

export const NoBraintrustTalentHired = (props: JobStatusBoxProps) => {
  return (
    <JobStatusBox color="var(--negative-1)" {...props}>
      <div>
        <JobStatusBox.Header>Job Closed</JobStatusBox.Header>
        <JobStatusBox.Subheader>
          No Braintrust Talent Hired
        </JobStatusBox.Subheader>
      </div>
    </JobStatusBox>
  );
};
